const loadingAnimation = require("./loadingAnimation");
const createHTMLElement = require("../dom/createHTMLElement");
const appendToComponent = require("../dom/appendToComponent");

/**
 * @return {HTMLDialogElement}
 */
module.exports = function loadingDialog() {
    const loadingAnimation$ = loadingAnimation();

    const loadingDialog$ = createHTMLElement(`
        <dialog class="dialog">
            <div data-component="loadingAnimation"></div>
        </dialog>
    `);

    appendToComponent(loadingDialog$, "loadingAnimation", loadingAnimation$);

    return loadingDialog$;
}